export interface Testimonial {
  id: string;
  name: string;
  avatarSeq: string;
  role: string;
  course: string;
  rating: number;
  content: string;
  date: string;
}

export interface Stat {
  id: string;
  value: string;
  label: string;
  icon: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-001',
    name: '张明',
    avatarSeq: 'avatar-zhang',
    role: 'IT工程师',
    course: '日语零基础到N3系统精讲',
    rating: 5,
    content: '作为一名工作繁忙的程序员，一直想学日语但找不到合适的方法。这个课程让我在通勤和午休时间也能高效学习，田中考师的讲解非常清晰，半年时间我从完全零基础达到了能和日本同事简单交流的水平！',
    date: '2026-06-15',
  },
  {
    id: 't-002',
    name: '李婷',
    avatarSeq: 'avatar-li',
    role: '市场营销经理',
    course: '韩国职场韩语与企业文化',
    rating: 5,
    content: '因为公司业务拓展到韩国，急需学习职场韩语。这个课程非常实用，不仅教会了我商务韩语表达，还深入讲解了韩国企业文化，让我在第一次出差时就给韩国合作伙伴留下了很好的印象。',
    date: '2026-06-20',
  },
  {
    id: 't-003',
    name: '王芳',
    avatarSeq: 'avatar-wang',
    role: '自由职业者',
    course: '日本传统文化深度赏析',
    rating: 5,
    content: '一直对日本文化很感兴趣，这个课程满足了我的所有期待。小林老师对茶道和花道的讲解让我仿佛身临其境，现在我已经开始在自己的生活中实践这些美学理念了。',
    date: '2026-07-01',
  },
  {
    id: 't-004',
    name: '陈强',
    avatarSeq: 'avatar-chen',
    role: '大学生',
    course: '韩国名校本科申请攻略',
    rating: 4,
    content: '在崔老师的指导下，我成功申请到了延世大学的本科项目。课程中对申请材料的详细分析和面试模拟练习特别有帮助，让我在真正的面试中充满自信。',
    date: '2026-07-10',
  },
  {
    id: 't-005',
    name: '刘洋',
    avatarSeq: 'avatar-liu',
    role: '外贸业务员',
    course: '韩语入门到TOPIK II通关',
    rating: 5,
    content: '因为经常和韩国客户打交道，决定系统学习韩语。朴老师的教学方式非常生动有趣，结合K-pop和韩剧的教学让学习过程一点都不枯燥，半年时间我已经通过了TOPIK 3级。',
    date: '2026-07-05',
  },
  {
    id: 't-006',
    name: '赵雪',
    avatarSeq: 'avatar-zhao',
    role: '人力资源总监',
    course: '日本职场商务日语与礼仪',
    rating: 5,
    content: '公司要在东京设立办事处，我作为HR负责人需要频繁与日本团队沟通。山本老师的课程让我快速掌握了商务日语的核心表达和日本职场的基本礼仪，非常实用！',
    date: '2026-07-18',
  },
];

export const stats: Stat[] = [
  { id: 's-1', value: '50,000+', label: '注册学员', icon: 'ri-user-star-line' },
  { id: 's-2', value: '200+', label: '精品课程', icon: 'ri-book-open-line' },
  { id: 's-3', value: '98%', label: '学员满意度', icon: 'ri-heart-line' },
  { id: 's-4', value: '30+', label: '资深讲师', icon: 'ri-team-line' },
];

export const teamMembers = [
  {
    id: 'team-1',
    name: '田中真由美',
    role: '日本区教学总监',
    title: '东京大学语言学博士',
    description: '拥有15年日语教学经验，曾任教于东京大学日语教育中心，专攻成人日语习得研究。',
    avatarSeq: 'team-tanaka',
  },
  {
    id: 'team-2',
    name: '朴智恩',
    role: '韩国区教学总监',
    title: '首尔大学韩国语教育硕士',
    description: '资深韩语教育专家，拥有丰富的在线教学经验，累计教授学员超过10,000人。',
    avatarSeq: 'team-park',
  },
  {
    id: 'team-3',
    name: '山本健一',
    role: '职场课程负责人',
    title: '早稻田大学MBA',
    description: '曾在三菱商事工作10年，深谙日本职场文化与商务礼仪，擅长将实战经验融入教学。',
    avatarSeq: 'team-yamamoto',
  },
  {
    id: 'team-4',
    name: '金秀雅',
    role: '文化课程负责人',
    title: '梨花女子大学文化研究博士',
    description: '韩国文化研究学者，专注于韩国现代文化与全球化传播研究，授课风格生动有趣。',
    avatarSeq: 'team-kim',
  },
];